function setAPIURL(environment) {
  if (environment === 'development') {
    return 'https://dev.cx-ray.com';
  }

  if (environment === 'staging') {
    return 'https://test.cx-ray.com';
  }

  if (environment === 'production') {
    return 'https://go.cx-ray.com';
  }

  return 'http://localhost:3000';
}

export default setAPIURL;
